import React from 'react';
import { BreachRecord } from '../../types';

interface Props {
  breaches: BreachRecord[];
  title?: string;
}

const actionLabels: Record<BreachRecord['actionTaken'], { label: string; color: string }> = {
  moved_to_backlog: { label: 'Moved to Backlog', color: 'bg-gray-100 text-gray-700' },
  moved_to_next_sprint: { label: 'Moved to Next Sprint', color: 'bg-blue-100 text-blue-700' },
  extended_in_place: { label: 'Extended in Place', color: 'bg-yellow-100 text-yellow-800' },
};

const BreachHistory: React.FC<Props> = ({ breaches, title = 'Breach History' }) => {
  if (!breaches || breaches.length === 0) return null;

  const formatDate = (dateStr: string) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  return (
    <div className="mt-4">
      <h4 className="text-sm font-semibold text-gray-800 mb-2">{title}</h4>
      <div className="space-y-3">
        {breaches.map((b, idx) => {
          const action = actionLabels[b.actionTaken];
          return (
            <div
              key={idx}
              className="border-l-4 border-red-400 bg-white rounded-r-lg p-3 shadow-sm"
            >
              <div className="flex flex-wrap items-center gap-2 mb-2">
                <span className="text-sm text-gray-700">
                  <span className="text-red-500 line-through">{formatDate(b.originalDeadline)}</span>
                  <span className="mx-1 text-gray-400">&rarr;</span>
                  <span className="text-green-600 font-medium">{formatDate(b.newDeadline)}</span>
                </span>
                <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${action.color}`}>
                  {action.label}
                </span>
              </div>

              <p className="text-sm text-gray-700 mb-1">
                <span className="font-semibold">Reason:</span> {b.reason}
              </p>
              <p className="text-sm text-gray-700 mb-2">
                <span className="font-semibold">Measures taken:</span> {b.measuresTaken}
              </p>

              <p className="text-xs text-gray-400">
                Recorded by {b.recordedByName || b.recordedBy} on {formatDate(b.breachedAt)}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BreachHistory;
